import request from '@/utils/request'

/**
 * 查询退款订单列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAdminRefundOrders(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/refundOrder.queryAdminRefundOrders',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询管理员店铺列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopsByAdmin(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopsByAdmin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}